
const fn = async () => {
  return 'listFn'
}

export default fn
